import { createSelector } from '@reduxjs/toolkit';
export const popupIdSelector = createSelector((state, winId) => state.registeredPopUpWinMap[winId], data => {
    return data;
});
export const popupIdSelectorNew = createSelector((state) => state.popupReducer.registeredPopUpWinMap, (state, winId) => winId, (all, winId) => {
    console.log('[popup selector]', winId, all);
    return all[winId];
});
export const popupShowedSelector = createSelector((state) => state.currentShowedPopUpWin, data => data);
export const popupIdPrefixSelectorNew = createSelector((state) => state.popupReducer.registeredPopUpWinMap, (state, winPrefix) => winPrefix, (all, winPrefix) => {
    console.log('[popup selector]', winPrefix, all);
    const data = [];
    if (winPrefix && winPrefix.length > 0) {
        Object.keys(all).forEach(key => {
            if (key && key.startsWith(winPrefix) && /^[0-9]+$/.test(key.substring(winPrefix.length))) {
                const item = all[key];
                data.push(item);
            }
        });
    }
    return data;
});
